import { useOnlineStatus } from '../../lib/use-online-status';

/**
 * Top-of-app banner shown whenever the browser is offline (Phase 5
 * Stufe I Slice 8). Mounted once in __root.tsx so it covers every page.
 */
export function OfflineBanner(): JSX.Element | null {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="border-b border-amber-300 bg-amber-100 px-4 py-2 text-center text-sm font-medium text-amber-900"
    >
      Keine Internetverbindung — Daten möglicherweise veraltet, Aktionen werden fehlschlagen.
    </div>
  );
}
